import { Provider } from 'react-redux';
import {
  loadTranslations,
  setLocale,
  syncTranslationWithStore,
} from 'react-redux-i18n';

import { ProfileSettings } from './ProfileSettings';
import { createStore } from '@common/utils/redux';
import { profileSettingsReducers } from './reducers';
import { profileSettingsEN } from './translations/en';
import { profileSettingsES } from './translations/es';
import { profileSettingsJA } from './translations/ja';
import { initializeRootAndReturnRender, unmountReactNode } from '@common/utils/react';

export const initProfileSettings = function (userName, locale) {
  const store = createStore(profileSettingsReducers);

  syncTranslationWithStore(store);

  const translation = {
    en: profileSettingsEN,
    ja: profileSettingsJA,
    es: profileSettingsES,
  };

  if (!translation[locale]) {
    locale = 'en';
  }

  store.dispatch(loadTranslations(translation));
  store.dispatch(setLocale(locale));

  const container = document.createElement('div');

  document.body.appendChild(container);

  const { root, render } = initializeRootAndReturnRender(
    container
  );
  const close = () => unmountReactNode(root);

  render(
    <Provider store={store}>
      <ProfileSettings userName={userName} close={close} />
    </Provider>,
  );
};
